import React from 'react';
import '../../assets/css/Projects.css'; 
import ProjectGrid from '../ProjectGrid';
import projectList from '../ProjectList';
import CompactSideBar from '../CompactSidebar';

export default class Projects extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = { projects: projectList };
    };

    render()
    {
        return(
            <div>
                <CompactSideBar/>
                <div className="Project">
                <ProjectGrid projects={ this.state.projects }/>
                </div>
            </div>
        );
    };
}